import { render, staticRenderFns } from "./vr.vue?vue&type=template&id=83424d1e&scoped=true&"
import script from "./vr.vue?vue&type=script&lang=js&"
export * from "./vr.vue?vue&type=script&lang=js&"
import style0 from "./vr.vue?vue&type=style&index=0&id=83424d1e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83424d1e",
  null
  
)

export default component.exports